// BE ENDPOINTS
import * as urls from './beEndpoints';

export const NAME = 'fetchStore';

export { urls };

export default { NAME, urls };
